import * as React from 'react';
import Screen from '../../../../../shared/components/screen';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {useStyles} from '../../../../../shared/hooks/styles';
import {EmailConfirmation} from '../../../common/emailConfirmation';

export default () => {
  const styles = useStyles(() => {
    return {
      scrollContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'stretch',
      },
    };
  });

  return (
    <Screen>
      <CustomScrollView contentContainerStyle={styles.scrollContainer} contentInsetAdjustmentBehavior='automatic'>
        <EmailConfirmation />
      </CustomScrollView>
    </Screen>
  );
};
